import React from "react";
import { Helmet } from "react-helmet";
import HeroSlider from "../components/HeroSlider";
import { useTranslation } from 'react-i18next';

const Home = () => {
  const {t} = useTranslation();
  return (
    <>
      <div className="home-page">
        <Helmet>
          <title>
            About | Min & Ying Legal Services Professional Corporation
          </title>
          <meta
            name="description"
            content="About | Min & Ying Legal Services Professional Corporation"
          />
        </Helmet>

        <HeroSlider/>
        {/* HERO=========== */}
        {/* <div className="container-fluid">
          <div className="row">
            <div className="hero-section">
              <div className="hero-overlay"></div>
              <div className="text-container d-flex flex-column justify-content-start align-items-start pt-6 slide">
                <div className="text-1 fs-2 pb-3">Min & Ying Legal Services Professional Corporation Professional Corporation</div>
                <div className="text-2 fs-4">
                  BIROU DE AVOCAT SI INSOLVENTA
                  <span className="fw-bold">
                    <br></br> Bucuresti{" "}
                  </span>
                </div>
                <div className="text-3 fst-italic fw-light">
                  "Nu este o adevărată justiție acolo unde nu există dreptate,
                  iar dreptatea nu poate fi găsită acolo unde nu există adevăr."
                  - <span>Lucius Annaeus Seneca.</span>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/*TE CONFRUNTI CU O PROBLEMA========= */}
        <div className="container-fluid container">
          <div className="row gap-6 p-5 mobile-padding align-items-start">
            <div className="col-12 col-xl-6">
              <h5 className="guide-text font-weight-bold mb-3">{t('about.intro')}</h5>
              <p>
                {t('about.introText')}
              </p>

              <p>{t('about.weAreDedicated')}:</p>
              <ul>
                <li>{t('about.case1')}</li>
                <li>{t('about.case2')}</li>
                <li>{t('about.case3')}</li>
                <li>{t('about.case4')}</li>
                <li>{t('about.case5')}</li>
                <li>{t('about.case6')}</li>
              </ul>
            </div>

            <div className="col-12 col-xl-6 d-flex align-items-center justify-content-start flex-wrap py-4">
              {["image1.png", "image2.jpeg", "image3.jpeg", "image4.jpeg"].map((src) => (
                <div
                  key={src}
                  className="p-2 bg-white rounded-3 shadow-sm"
                  style={{
                    width: "200px",
                    height: "200px",
                    overflow: "hidden",
                    transition: "transform 0.3s ease",
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.03)")}
                  onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
                >
                  <img
                    src={`/assets/contact/${src}`}
                    className="img-fluid w-100 h-100 rounded-2"
                    alt="a gavel, scales of justice, and law books"
                    style={{ objectFit: "cover" }}
                  />
                </div>
              ))}
            </div>
            <h5 className="guide-text font-weight-bold mt-5 mx-3">{t('about.ourTeams')}</h5>
            <div className="container-fluid container py-5">
              <div className="row">
                <div className="col-12 col-md-6 d-flex flex-column align-items-center mb-4 mb-md-0">
                  <div
                    className="p-2"
                    style={{
                      width: "100%",
                      height: "400px",
                      overflow: "hidden",
                      transition: "transform 0.3s ease",
                    }}
                    onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.03)")}
                    onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
                  >
                    <img
                      src="/assets/mandy.jpg" // make sure this filename matches your assets
                      className="img-fluid w-100 h-100 rounded-2"
                      alt="Min Yi Pan (Mandy)"
                      style={{ objectFit: "contain" }}
                    />
                  </div>
                  <div className="text-center mt-2">
                    <div className="fw-bold">Min Yi Pan (Mandy)</div>
                    <div style={{ fontSize: "0.9rem" }}>{t('about.fields')}</div>
                  </div>
                </div>

                <div className="col-12 col-md-6 d-flex flex-column align-items-center">
                  <div
                    className="p-2"
                    style={{
                      width: "100%",
                      height: "400px",
                      overflow: "hidden",
                      transition: "transform 0.3s ease",
                    }}
                    onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.03)")}
                    onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
                  >
                    <img
                      src="/assets/yanni.jpg" // make sure this filename matches your assets
                      className="img-fluid w-100 h-100 rounded-2"
                      alt="Yingen Mai (Yanni)"
                      style={{ objectFit: "contain" }}
                    />
                  </div>
                  <div className="text-center mt-2">
                    <div className="fw-bold">Yingen Mai (Yanni)</div>
                    <div style={{ fontSize: "0.9rem" }}>{t('about.fields')}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>

      </div>
    </>
  );
};

export default Home;
